import React from 'react';
import Dialog from 'src/components/dialog/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import type { ISnippet } from 'src/services/api';
import { Flex } from 'src/components/flex';
import SnippetsModalList from 'src/pages/landlord/leads/messages/components/snippets-modal/components/SnippetsModalList';
import SnippetsSearch from 'src/pages/landlord/leads/messages/components/snippets-modal/components/SnippetsSearch';

interface Props {
    open: boolean;
    onClose: React.Dispatch<React.SetStateAction<boolean>>;
    snippets: ISnippet[];
    setIsAddingSnippet: React.Dispatch<React.SetStateAction<boolean>>;
    setSnippetsModalOpen: (snippetsModalOpen: boolean) => void;
}

export default function SnippetsModal ({
    open,
    onClose,
    snippets,
    setIsAddingSnippet,
    setSnippetsModalOpen,
}: Props) {
    return (
        <Dialog
            open={open}
            onClose={() => onClose(false)}
            maxWidth="md"
            PaperProps={{
                sx: {
                    width: '100%',
                    height: '580px',
                }
            }}
        >
            <DialogTitle sx={{ borderBottom: '1px solid #EFEFEA', py: 1.5 }}>
                <Flex justifyContent="space-between" alignItems="center" mb={1}>
                    Snippets
                    <IconButton onClick={() => onClose(false)}>
                        <CloseIcon />
                    </IconButton>
                </Flex>
                <SnippetsSearch />
            </DialogTitle>
            <DialogContent sx={{ px: 0 }}>
                <SnippetsModalList
                    snippets={snippets}
                    setSnippetsModalOpen={setSnippetsModalOpen}
                />
            </DialogContent>
            <DialogActions sx={{ borderTop: '1px solid #EFEFEA' }}>
                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddIcon />}
                    onClick={() => setIsAddingSnippet(true)}
                    sx={{ fontSize: '14px' }}
                >
                    Add Snippet
                </Button>
            </DialogActions>
        </Dialog>
    );
}